import api from 'api'

export type ListingFunnelEvent = {
  name: string
  eventType: string | null
  rawEventType: string
  eventTime: string
}

export type ListingFunnelEventsResponse = {
  listingId: number
  workerId: number
  startDate: string
  endDate: string
  events: ListingFunnelEvent[]
}

export async function getListingFunnelEvents(
  listingId: number,
  workerId: number,
  timeRange: { startDate: string; endDate: string }
) {
  const response = await api.get<ListingFunnelEventsResponse>(
    `/admin/listing/${listingId}/funnel/events`,
    { params: { workerId, ...timeRange } }
  )
  return response.data
}
